import React, { Component } from 'react';
import Translations from './models/Translations';
import SearchPage from '../views/pages/SearchPage';
import SearchService from './services/search.service';

type AppProps = {
  itemsPerPage: number,
  translations: Translations,
  language: string,
  persona: string,
  pageTitle: string,
  keywords: string,
  summaryLength: number,
}

type AppState = {
  service: SearchService,
}

export default class App extends Component<AppProps, AppState> {
  constructor(props: AppProps) {
    super(props);
    const service = new SearchService();
    this.state = {
      service: service
    };
  }

  public render() {
    return (
      <>
        {
          <SearchPage pageTitle={this.props.pageTitle} initialKeywords={this.props.keywords} service={this.state.service} itemsPerPage={this.props.itemsPerPage} startPage={1} translations={this.props.translations} persona={this.props.persona} language={this.props.language} summaryLength={this.props.summaryLength} />
        }
      </>
    );
  }
}